import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../../forms/footerSection/footer/footer.component';
import { EsupportSectionComponent } from '../../forms/esupport/esupport-section/esupport-section.component';
import { WebCoordinatorSectionComponent } from '../../forms/webCoordinator/web-coordinator-section/web-coordinator-section.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { AttachmentPickerSectionComponent } from '../../forms/attachmentPicker/attachment-picker-section/attachment-picker-section.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { HeaderComponent } from '../../forms/headerSection/header/header.component';
import { IqacFromsFooterComponent } from '../../forms/iqac-froms-footer/iqac-froms-footer.component';
import { AttachmentDocumentSectionComponent } from '../../forms/attachmentPicker/attachment-document-section/attachment-document-section.component';
import { OfficeAttachmentSectionComponent } from '../../forms/attachmentPicker/office-attachment-section/office-attachment-section.component';
import { CommonFieldComponent } from '../../forms/commonFieldSection/common-field/common-field.component';
import { DeptFieldsComponent } from '../../forms/commonFieldSection/dept-fields/dept-fields.component';
import { CommitteeFieldComponent } from '../../forms/commonFieldSection/committee-field/committee-field.component';
import { InvolvedStaffFieldComponent } from '../../forms/commonFieldSection/involved-staff-field/involved-staff-field.component';
import { AdminRemarksComponent } from '../../forms/commonFieldSection/admin-remarks/admin-remarks.component';
import { DefaultFooterComponent } from '../../forms/footerSection/default-footer/default-footer.component';
import { AppNativeHeaderComponent } from '../../forms/headerSection/app-native-header/app-native-header.component';
import { FABModule } from 'src/app/components/fab/fab.module';
import { EnhancedDeptFieldsComponent } from '../../forms/commonFieldSection/enhanced-dept-fields/enhanced-dept-fields.component';
import { DeptSelectionModalComponent } from '../../forms/commonFieldSection/dept-selection-modal/dept-selection-modal.component';
import { EnhancedCommitteeFieldComponent } from '../../forms/commonFieldSection/enhanced-committee-field/enhanced-committee-field.component';
import { CommitteeSelectionModalComponent } from '../../forms/commonFieldSection/committee-selection-modal/committee-selection-modal.component';
import { EnhancedStaffFieldComponent } from '../../forms/commonFieldSection/enhanced-staff-field/enhanced-staff-field.component';
import { StaffSelectionModalComponent } from '../../forms/commonFieldSection/staff-selection-modal/staff-selection-modal.component';

@NgModule({
  declarations: [
    EsupportSectionComponent,
    WebCoordinatorSectionComponent,
    AttachmentPickerSectionComponent,
    FooterComponent,
    HeaderComponent,
    AppNativeHeaderComponent,
    IqacFromsFooterComponent,
    AttachmentDocumentSectionComponent,
    OfficeAttachmentSectionComponent,
    CommonFieldComponent,
    DeptFieldsComponent,
    CommitteeFieldComponent,
    InvolvedStaffFieldComponent,
    AdminRemarksComponent,
    EnhancedDeptFieldsComponent,
    DeptSelectionModalComponent,
    EnhancedCommitteeFieldComponent,
    CommitteeSelectionModalComponent,
    EnhancedStaffFieldComponent,
    StaffSelectionModalComponent
  ],
  imports: [CommonModule, IonicModule, FormsModule, NgxDropzoneModule, FABModule],
  exports: [
    EsupportSectionComponent,
    WebCoordinatorSectionComponent,
    FooterComponent,
    CommonModule,
    IonicModule,
    AttachmentPickerSectionComponent,
    AttachmentDocumentSectionComponent,
    OfficeAttachmentSectionComponent,
    HeaderComponent,
    AppNativeHeaderComponent,
    IqacFromsFooterComponent,
    CommonFieldComponent,
    DeptFieldsComponent,
    CommitteeFieldComponent,
    InvolvedStaffFieldComponent,
    AdminRemarksComponent,
    FABModule,
    EnhancedDeptFieldsComponent,
    EnhancedCommitteeFieldComponent,
    EnhancedStaffFieldComponent
  ]
})
export class SharedModule {}
